import {
    useCallback,
    useEffect,
    useMemo,
    useState } from "react";
import SnpComponent from "../global/SnpComponent";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Box,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    Paper,
    TextField } from "../ui";
import CustomDataGrid from "../global/CustomDataGrid";
import RenderSearchChoice from "./mart/RenderSearchChoice";
import {
  BillFromMachine,
  BillStatus,
  CART_INITIAL_STATE,
  CartDets,
  ChooseItemPrices,
  DEF_BILL_PRICES,
  DEF_SELECT_SEARCH,
  getDeviceType,
  getPreUrlAccordingToCart,
  GETPRODDETAILS,
  GETSINGLECONFIGS,
  isEmpty,
  isRoleAllowed,
  ItemStatus,
  local_test_url,
  OfferType,
  PayMedium,
  printDebugLog,
  printInfoLog,
  SearchOption,
  SUCCESS,
  test_environment_mode,
  TRIP_DELIVERED,
  twoDecimal,
  isOtherRoleAllowed,
  OTHER_ADMIN_RIGHTS,
  ROLE_CREATE,
  BILLMGMT,
  ONLINEBILLMGMT
} from "../../constants/constant";
import axios from "axios";
import { snpAxios } from "../global/api";
import AddIcon from '../ui/icons/Add';
import RemoveIcon from '../ui/icons/Remove';
import RenderCustomerInfo from "./mart/RenderCustomerInfo";
import DialogBox from "../global/DialogBox";
import RenderDialogContent from "./mart/RenderDialogContent";
import DismissButton from "../global/DismissButton";
import RenderBillInfo from "./mart/RenderBillInfo";
import { makeStyles } from "../ui";
import EnterButton from "../global/EnterButton";
import RenderBillHeader from "./mart/RenderBillHeader";
import uiUtilInstance from "../../utilities/uiUtil";
import SnpButton from "../global/SnpButton";
import { baseColumnRateCard, getColumnByItemIndex } from "./mart/BillItemAddUseCase";
import WarningIcon from '../ui/icons/Warning';
import { baseRaiseInvoiceClicked } from "./printBillApi";
import RenderComboDialog from "./mart/RenderComboDialog";
import DeliveryStatusChange from "./common/DeliveryStatusChange";

export default function MartBilling() {

    const useStyles = makeStyles({
        input: {
            '& input[type=number]': {
                '-moz-appearance': 'textfield'
            },
            '& input[type=number]::-webkit-outer-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0
            },
            '& input[type=number]::-webkit-inner-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0
            }
        },
    });
    const colQuantityClasses = useStyles();

    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const [isMobile, setIsMobile] = useState(window.matchMedia('(max-width: 767px)').matches);
    //const dispatch = useDispatch();
    const location = useLocation();
    //const navigate = useNavigate();

    const INITIAL_SNP_COMPONENT = {
        showDialog: false,
        outSideClickDismiss: true,
        title: "",
        subTitle: "",
        negativeAction: "",
        positiveAction: "",
        positiveReq: false,
        isLoader: false,
        iconReq: false,
        iconContent: "",
        snackBarOpen: false,
        snackBarMsg: "",
        cancelExtra: false,
        negativeReq: false,
        requestType: 0,
        handleSnpSubmit: null,
        handleSnpCancel: null,
        gui: "",
        snackVertical: "",
        snackHorizontal: "",
        snackColor: "",
    };

    const INITIAL_CUSTOMER_DATA = {
        custId: "",
        custMob: "",
        associateId: "",
        custName: "",
        custEmail: "",
        address: "",
        custGstDetails: "",
        custCompanyName: "",
        assosiateAvailable: false,
        useAssociateBenefit: false,
    };

    const INITIAL_ITEM_DETAILS = {
        name: "",
        rack_no: "",
        prdId: "",
        prdType: "",
        composition: "",
        catgName: "",
    };

    const INITIAL_COMBO_DETAILS = {
        prdId: "",
        name: "",
        offerType: OfferType.No_Offer,
        offerAmt: 0.0,
        price: 0.0,
        subTotalPrice: 0.0,
        appliedOfferAmt: 0.0,
        unit: "",
        choosePrices: ChooseItemPrices.Customer_Prices,
        totalCgstAmt: 0.0,
        totalSgstAmt: 0.0,
        listBarCode: [],
        listBatch: [],
        stockRefNo: [],
    }

    const INITIAL_UNIT = {
        unitName: "",
        unitRestrictions: false,
        smallUnitName: "",
        smallUnitCount: 0,
        decimalSmRestrictions: false,
    }

    const INITIAL_ITEM_MGMT = {
        sbcCessTax: 0.0,
        liveStockData: "",
        freeStockCount: "",
        totalCount: [],
        freeCount: [],
        bigPrice: {},
        smallPrice: {}
    };

    const INITIAL_PAYMENT_MODEL = {
        onlinePayMedium: "",
        onlinePay: 0.0,
        cashPay: 0.0,
        walletAmt: 0.0,
        // totalItem:0,
        subTotal: 0.0,
        cgstAmt: 0.0,
        sgstAmt: 0.0,
        isGstAllowed: true,
        roundOff: 0.0,
        total: 0.0,
        totalBeforeOffer: 0.0,
        offerDenom: OfferType.No_Offer,
        offerAmt: 0.0,
        billStatus: BillStatus.NO_ENTRY,
        cashTender: 0.0,
        cashReturn: 0.0,
        totalOfferApplied: 0.0,
        payMedium: PayMedium.NOPAY,
        isOnlinePayEnabled: false,
        isCashPayEnabled: false,
        externalTotalOffer: 0.0,
    };



    const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);
    const [snpLoader, setSnpLoader] = useState(false);

    const [defaultId, setDefaultId] = useState(SearchOption.SEARCHBYBARC);
    const [configDefaultId, setConfigDefaultId] = useState(SearchOption.SEARCHBYBARC);
    const [searchText, setSearchText] = useState("");
    const [productSearchLoader, setProductSearchLoader] = useState(false);
    const [listStock, setListStock] = useState([]);
    const [columnList, setColumnList] = useState([]);

    const [itemDetails, setItemDetails] = useState(INITIAL_ITEM_DETAILS);
    const [comboDetails, setComboDetails] = useState(INITIAL_COMBO_DETAILS);
    const [cnvMap, setUnit] = useState(INITIAL_UNIT);
    const [management, setItemMgmt] = useState(INITIAL_ITEM_MGMT);

    const [stockInfos, setStockInfos] = useState([]);
    const [listProduct, setListProduct] = useState([]);
    const [comboExist, setComboExist] = useState("");
    const [defChoosePrices, setChoosePrice] = useState(ChooseItemPrices.Customer_Prices);
    const [configChoosePrice, setConfigChoosePrice] = useState(ChooseItemPrices.Customer_Prices);
    const [defChooseUnit, setChooseUnit] = useState("");
    const [selectedStockMap, setSelectedStockMap] = useState(new Map());
    const [selectedItemIndex, setSelItemIndex] = useState(-1);
    const [editClick, setEditClick] = useState(false);
    const [itemQuantity, setItemQuantity] = useState(1);
    const [quanChangeBlock, setQuanChangeBlock] = useState(false);
    const [showItemDialog, setShowItemDialog] = useState(false);
    const [comboDialog, setComboDialog] = useState(false);
    const [lastStockSelected, setLastStockSelected] = useState("");

    const [customerData, setCustomerData] = useState(INITIAL_CUSTOMER_DATA);
    const [isPaid, setIsPaid] = useState(false);
    const [billNo, setBillNo] = useState("");
    const [billedFrom, setBilledFrom] = useState(BillFromMachine.BILLING_MACHINE);
    const [createdDate, setCreatedDate] = useState(uiUtilInstance.todayFormattedDate);
    const [paymentDetails, setPaymentDetails] = useState(INITIAL_PAYMENT_MODEL);

    //Regarding Delivery
    const [billData, setBillData] = useState({});
    const [statusDialog, setStatusDialog] = useState(false);
    const [rejectDialog, setRejectDialog] = useState(false);
    const [reasonDialog, setReasonDialog] = useState(false);
    const [deliveredDialog, setDeliveredDialog] = useState(false);
    const [rejectionReason, setRejectionReason] = useState("");
    const isRejected = Number(paymentDetails.billStatus) === BillStatus.FAILED_ONLINE_PAYMENT;
    const hasOnlinePaymentReference = !isEmpty(billData?.thirdParty?.orderId ?? "")
        || !isEmpty(billData?.thirdParty?.sessionId ?? "");
    const isBillLocked = isPaid || hasOnlinePaymentReference || isRejected;


    const columns = [
        {
            field: 'name', headerName: 'Item', width: 230, valueGetter: (params) => params.row.name, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{params.value}</p>
            ),
        },
        {
            field: 'quantity', headerName: 'Qty. /unit', minWidth: 180, width: 210,
            renderCell: (val) => {
                return (
                    <Grid container spacing={0}>
                        <Grid item md={12} sm={12} xs={12} lg={12}>
                            <TextField
                                id="colQuantity"
                                className={colQuantityClasses.input}
                                name="colQuantity"
                                type="text"
                                value={val.row.quantity + " " + val.row.unit}
                                variant="standard"
                                size="small"
                                disabled
                                sx={{
                                    justifyContent: "center", alignContent: "center",
                                    '& .UiInputBase-input': {
                                        textAlign: "center",
                                    },
                                    "& .UiInputBase-input.Ui-disabled": {
                                        color: "rgba(4, 63, 34, 0.88) !important",
                                        "-webkit-text-fill-color": "rgba(4, 63, 34, 0.88) !important",
                                        opacity: 1,
                                        fontWeight: "bold"
                                    }
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <IconButton onClick={() => handleIncrement(val.row)}>
                                                <AddIcon color="success" sx={{
                                                    fontSize: "2rem",
                                                }} />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => handleDecrement(val.row)}>
                                                <RemoveIcon color="warning" sx={{
                                                    fontSize: "2rem",
                                                }} />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Grid>
                    </Grid>
                );
            },
        },
        {
            field: 'price', headerName: 'MRP', width: 100,
            renderCell: (val) => {
                return "\u20B9 " + twoDecimal(val.row.price);
            }

        },
        {
            field: 'offer', headerName: 'Offer', width: 100,
            renderCell: (val) => {
                return (parseInt(val.row.offerDenom) === OfferType.Flat) ?
                    "Flat" + twoDecimal(val.row.offerAmt) : (parseInt(val.row.offerDenom) === OfferType.Percentage) ? twoDecimal(val.row.offerAmt) + "%" :
                        0.0;
            }
        },
        // {
        //     field: 'cgstAmt', headerName: 'Cgst', width: 100,
        //     renderCell: (val) => {
        //         return "\u20B9 " + val.row.cgstAmt+"("+val.row.cgst+"%)";
        //     }

        // },
        // {
        //     field: 'sgstAmt', headerName: 'Sgst', width: 100,
        //     renderCell: (val) => {
        //         return "\u20B9 " + val.row.sgstAmt+"("+val.row.sgst+"%)";
        //     }

        // },
        {
            field: 'finalPrice', headerName: 'T. Price', width: 100,
            renderCell: (val) => {
                return "\u20B9 " + twoDecimal(val.row.finalPrice);
            }
        },
        {
            field: "edit",
            headerName: "",
            renderCell: (cellValues) => {
                return (
                    <SnpButton variant="contained"
                        mbgcolor="#538796"
                        mpadding="1px"
                        onClick={() => {
                            if (isBillLocked)
                                setSnpComponent({
                                    ...snpComponent,
                                    snackBarMsg: "This bill is locked and cannot be edited",
                                    snackBarOpen: true,
                                });
                            else
                                handleCellClick("edit", cellValues.row);
                        }}
                    >Edit</SnpButton>
                );
            }
        },
        {
            field: "del",
            headerName: "",
            renderCell: (cellValues) => {
                return (
                    <SnpButton variant="contained"
                        mbgcolor="#ca241e"
                        mpadding="1px"
                        onClick={() => {
                            if (isBillLocked)
                                setSnpComponent({
                                    ...snpComponent,
                                    snackBarMsg: "This bill is locked and cannot be deleted",
                                    snackBarOpen: true,
                                });
                            else
                                handleCellClick("del", cellValues.row);
                        }}
                    >Del</SnpButton>
                );
            }
        },
    ];

    const saveInitiateBillDisable = useMemo(() => isBillLocked || snpLoader ||
        (Array.isArray(columnList) && columnList.length === 0) || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE), [isBillLocked, snpLoader, columnList]);

    const printBillDisable = useMemo(() => !isPaid || snpLoader
        || (Array.isArray(columnList) && columnList.length === 0)
        || isEmpty(billNo), [isPaid, billNo, snpLoader, columnList]);


    useEffect(() => {
        printDebugLog("useEffect:paymentDetails", paymentDetails);
    }, [paymentDetails]);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 767px)');
        //var currentTime = +new Date();
        const userAgent = navigator.userAgent;
        const handleMediaQueryChange = (event) => {
            let deviceType = getDeviceType(userAgent);
            let width = window.innerWidth;
            printDebugLog("deviceType<=", deviceType, event.matches, width);
            if (deviceType === 'Tablet') {
                setIsMobile(true);
            } else if (width <= 1280) {
                setIsMobile(true);
            } else
                setIsMobile(event.matches);
        };

        mediaQuery.addEventListener('change', handleMediaQueryChange);
        window.addEventListener("popstate", handleMediaQueryChange);
        window.addEventListener("hashchange", handleMediaQueryChange);
        return () => {
            mediaQuery.removeEventListener('change', handleMediaQueryChange);
            window.removeEventListener("popstate", handleMediaQueryChange);
            window.removeEventListener("hashchange", handleMediaQueryChange);
        };
    }, []);

    useEffect(() => {
        printDebugLog("MartBilling", location.state?.prdId, location.state?.sBillNo);
        getSingleConfigs(DEF_SELECT_SEARCH);
        getSingleConfigs(DEF_BILL_PRICES);
        if (!isEmpty(location.state?.prdId)) {
            getMainStockDetails(SearchOption.SEARCHBYPRODN, location.state?.prdId, -1);
        }
        if (!isEmpty(location.state?.sBillNo)) {
            fetchBill(location.state?.sBillNo);
        }
    }, [storeApiUrl, storeActiveShopHash, location.state]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            //printDebugLog("handleKeyDown",event);
            if (!saveInitiateBillDisable && event.ctrlKey && event.key === 'i') {
                event.preventDefault();
                initiatePayment(false);
            } else if (!saveInitiateBillDisable && event.ctrlKey && event.key === 's') {
                event.preventDefault();
                initiatePayment(true);
            } if (!printBillDisable && event.ctrlKey && event.altKey && event.key === '2') {
                event.preventDefault();
                printBill(1);
            } else if (!printBillDisable && event.ctrlKey && event.altKey && event.key === '3') {
                event.preventDefault();
                printBill(0);
            } else if (!printBillDisable && event.ctrlKey && event.altKey && event.key === '4') {
                event.preventDefault();
                printBill(0);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [saveInitiateBillDisable, printBillDisable,
        isPaid, billNo, columnList, snpLoader, paymentDetails, customerData])


    const getSingleConfigs = async (mConfigName) => {
        try {
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${GETSINGLECONFIGS}?adminId=${CART_INITIAL_STATE.apiToken}&configName=${mConfigName}&shopHash=${storeActiveShopHash.id}`;
            const response = await axios.get(cUrl);
            printDebugLog(`getSingleConfigs:${mConfigName}`, response);
            if (response.data !== '') {
                if (mConfigName === DEF_BILL_PRICES) {
                    const val = Number(response.data) || ChooseItemPrices.Customer_Prices;
                    setChoosePrice(val);
                    setConfigChoosePrice(val);
                } else if (mConfigName === DEF_SELECT_SEARCH) {
                    const val = Number(response.data) || SearchOption.SEARCHBYBARC;
                    setDefaultId(val);
                    setConfigDefaultId(val);
                }
            }
        } catch (e) {
            console.error(`getSingleConfigs:Err${mConfigName}`, e);
        }
    };

    const upateDeliveryStatus = async () => {
        try {
            if (!billData) {
                fireSnackBarMsg({ msg: "No data to submit", mColor: "#7a0000" })
                return;
            }
            if (isEmpty(billData.tripDetails)) {
                fireSnackBarMsg({ msg: "No data to submit", mColor: "#7a0000" })
                return;
            }
            setSnpLoader(true);
            const data = {
                jcJson: {
                    apiToken: CART_INITIAL_STATE.apiToken,
                    shopHash: storeActiveShopHash.id,
                    deliveryInformation: billData.deliveryInformation,
                    homeDelvId: billData.homeDelvId,
                    tripDetails: billData.tripDetails,
                    delvName: billData.delvName,
                    id: billData.id,
                }
            }
            const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}mart-bill/update-delivery-status`;
            const response = await snpAxios.post(cartUrl, data);
            if (response.data.status === SUCCESS) {
                if (billData.tripDetails === TRIP_DELIVERED)
                    setDeliveredDialog(true);
            } else {
                setSnpLoader(false);
            }
        } catch (error) {
            console.error("upateDeliveryStatus", error);
        } finally {
            setStatusDialog(false);
        }
    };

    const rejectBill = async () => {
        const reason = rejectionReason.trim();
        if (isEmpty(reason)) {
            fireSnackBarMsgWithColor("Reason is mandatory", "#dc3545");
            return;
        }
        try {
            setSnpLoader(true);
            const response = await snpAxios.post(
                `${storeApiUrl.BACKEND_BASE_URL}mart-bill/reject-bill`,
                {
                    jcJson: {
                        apiToken: CART_INITIAL_STATE.apiToken,
                        shopHash: storeActiveShopHash.id,
                        billNo,
                        reason,
                    }
                }
            );
            if (response.data.status === SUCCESS) {
                setPaymentDetails(prev => ({
                    ...prev,
                    billStatus: BillStatus.FAILED_ONLINE_PAYMENT,
                }));
                setBillData(prev => ({ ...prev, reason }));
                setRejectDialog(false);
                setRejectionReason("");
                fireSnackBarMsgWithColor("Bill rejected successfully", "#198754");
            } else {
                fireSnackBarMsgWithColor(response.data?.message || "Unable to reject bill", "#dc3545");
            }
        } catch (error) {
            fireSnackBarMsgWithColor(error?.response?.data?.message || "Unable to reject bill", "#dc3545");
        } finally {
            setSnpLoader(false);
        }
    };

    const fetchBill = async (mBill) => {
        try {
            setSnpLoader(true);
            const fetchUrl = `${storeApiUrl.BACKEND_BASE_URL}mart-bill/fetch-bill-details`;
            const requestData = {
                jcJson: {
                    apiToken: CART_INITIAL_STATE.apiToken,
                    billNo: mBill,
                    shopHash: storeActiveShopHash.id,
                }
            }
            const response = await snpAxios.post(fetchUrl, requestData);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setBillNo(payLoad.billNo);
                setPaymentDetails(payLoad.paymentDetails);
                setCustomerData(payLoad.customerData);
                setIsPaid(payLoad.isPaid);
                setCreatedDate(payLoad.createdAt);
                setColumnList(payLoad.columnList);
                setBilledFrom(Number(payLoad.billedFrom));
                setBillData(prev => ({
                    ...prev,
                    id: payLoad.id,
                    delvName: payLoad.delvName,
                    homeDelvId: payLoad.homeDelvId,
                    deliveryInformation: payLoad.deliveryInformation,
                    tripDetails: payLoad.tripDetails,
                    destinationAddress: payLoad?.destinationAddress ?? "",
                    thirdParty: payLoad?.thirdParty ?? {},
                    reason: payLoad?.reason ?? "",
                }))
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("fetchBill error : ", error);
            setSnpLoader(false);
        }
    }

    const getProductDetails = async (stock) => {
        try {
            setProductSearchLoader(true);
            const productDetails = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${GETPRODDETAILS}?adminId=${CART_INITIAL_STATE.apiToken}&stock=${stock}&shopHash=${storeActiveShopHash.id}&type=${storeActiveShopHash.cartType}&status=${ItemStatus.ACTIVE}`;
            const response = await axios.get(productDetails, {});
            if (response.data.status === SUCCESS) {
                setListStock(response.data.jcJson.value_2);
            }
            setProductSearchLoader(false);
        } catch (error) {
            console.error("getProductDetails error : ", error);
            setProductSearchLoader(false);
        }
    };

    const getCustomStockDetails = async (stock) => {
        try {
            setSnpLoader(true);
            const productDetails = `${storeApiUrl.BACKEND_BASE_URL}mart-bill/get-single-stock-details-v2?adminId=${CART_INITIAL_STATE.apiToken}&shopHash=${storeActiveShopHash.id}&usedBenefits=${customerData.useAssociateBenefit ? 1 : 0}&stock=${stock}`;
            const response = await snpAxios.get(productDetails, {});
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                if (!Array.isArray(payLoad.stockInfos)) {
                    fireSnackBarMsgWithColor("No Stock available", "#e41e2e");
                } else if (payLoad.stockInfos.length === 0) {
                    fireSnackBarMsgWithColor("No Stock available", "#e41e2e");
                } else {
                    setListProduct(payLoad.fullPrdList);
                    addorUpdateItem(payLoad, -1);
                }
            }
            setSearchText("");
            setSnpLoader(false);
        } catch (error) {
            console.error("getCustomStockDetails error : ", error);
            setSnpLoader(false);
        }
    };

    const getComboMgmt = async (stock, type, mItemIndex) => {
        try {
            setSnpLoader(true);
            const productDetails = `${storeApiUrl.BACKEND_BASE_URL}mart-bill/get-combo-details?adminId=${CART_INITIAL_STATE.apiToken}&shopHash=${storeActiveShopHash.id}&type=${type}&stock=${stock}`;
            const response = await snpAxios.get(productDetails, {});
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                if (!Array.isArray(payLoad.stockInfos)) {
                    fireSnackBarMsgWithColor("No Stock available", "#e41e2e");
                } else if (payLoad.stockInfos.length === 0) {
                    fireSnackBarMsgWithColor("No Stock available", "#e41e2e");
                } else {
                    if (mItemIndex !== -1) {
                        setListProduct(payLoad.fullPrdList); //Here its combo
                        setComboDetails(payLoad.itemDetails);
                        setStockInfos(payLoad.stockInfos);
                        const item = getColumnByItemIndex(columnList, mItemIndex);
                        setItemQuantity(item.quantity);
                        setSelItemIndex(item.itemIndex);
                        setComboDialog(true);
                    } else {
                        const mComboDetails = payLoad.itemDetails;
                        const mItem = columnList && columnList.find(col => col.prdId === mComboDetails.prdId);
                        if (mItem) {
                            const mQuantity = mItem.quantity + 1;
                            handleBaseUpdateCombo(mComboDetails, mItem.itemIndex, mQuantity);
                        } else {
                            handleBaseUpdateCombo(mComboDetails, -1, 1);
                        }

                    }
                    setSearchText("");
                }
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("getComboMgmt error : ", error);
            setSnpLoader(false);
        }
    };

    const getStockGstPricesBasedOnPricenUnit = async (mChoosePrices, mChooseUnit, mUseAssociateBenefits, mStockRefNo) => {
        const mUsedBenefits = mUseAssociateBenefits ? 1 : 0;
        const mUrl = `${storeApiUrl.BACKEND_BASE_URL}mart-bill/get-stock-gst-based-price-unit-v2?shopHash=${storeActiveShopHash.id}&priceIndex=${mChoosePrices}&usedBenefits=${mUsedBenefits}&unit=${mChooseUnit}&stock=${mStockRefNo}`;
        try {
            const response = await snpAxios.get(mUrl);
            return response.data;
        } catch (err) {
            return null;
        }
    };


    const getStockDetails = async (stock) => {
        if (defaultId === SearchOption.SEARCHBYCUSTOMBARCODE) {
            getCustomStockDetails(stock);
        } else if (defaultId === SearchOption.SEARCHBYCOMBO) {
            getComboMgmt(stock, defaultId, -1);
        } else {
            getMainStockDetails(defaultId, stock, -1);
        }
    };

    const getMainStockDetails = async (mDefaultId, stock, mItemIndex) => {
        try {
            setSnpLoader(true);
            let mSearchId = Number(mDefaultId);
            let mPrice = 0.0;
            const item = mItemIndex === -1 ? null : columnList.length >= 1 ? getColumnByItemIndex(columnList, mItemIndex) : null;
            if (item !== null && item.choosePrices === ChooseItemPrices.Stock_Prices) {
                mSearchId = item.chooseUnit;
                mPrice = item.price;
            }
            const stockUrl = `${storeApiUrl.BACKEND_BASE_URL}mart-bill/get-stock-details`;
            const requestData = {
                jcJson: {
                    v2: true,
                    apiToken: CART_INITIAL_STATE.apiToken,
                    searchId: Number(mSearchId),
                    shopHash: storeActiveShopHash.id,
                    data: stock,
                    price: mPrice,
                    useAssociateBenefits: customerData.useAssociateBenefit,
                }
            }
            setSearchText('');
            setDefaultId(configDefaultId);
            const response = await snpAxios.post(stockUrl, requestData);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                if (!Array.isArray(payLoad.stockInfos)) {
                    fireSnackBarMsgWithColor("No Stock available", "#e41e2e");
                } else if (payLoad.stockInfos.length === 0) {
                    fireSnackBarMsgWithColor("No Stock available", "#e41e2e");
                } else {
                    setListProduct(payLoad.fullPrdList);
                    addorUpdateItem(payLoad, mItemIndex);
                }
            } else {
                setSelItemIndex(-1);
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("getStockDetails error : ", error);
            setSnpLoader(false);
            setSearchText('');
            setSelItemIndex(-1);
        }
    };

    const initiatePayment = async (saveBill) => {
        printDebugLog("initiatePayment", saveBill);

        if (paymentDetails.payMedium !== PayMedium.ASSOCIATE_WALLET && !saveBill && (!paymentDetails.isCashPayEnabled && !paymentDetails.isOnlinePayEnabled)) {
            fireSnackBarMsg("Please Select any of the Payment method", "right", "top", "#ff954a");
            return;
        }
        if (!saveBill && paymentDetails.isOnlinePayEnabled && isEmpty(paymentDetails.onlinePayMedium)) {
            fireSnackBarMsg("Please Select Online Pay Method", "right", "top", "#ff954a");
            return;
        }
        if (isEmpty(customerData.custMob)) {
            fireSnackBarMsg("Please Add Customer Details", "right", "top", "#ff954a");
            return;
        }
        try {
            setSnpLoader(true);
            const billUrl = `${storeApiUrl.BACKEND_BASE_URL}mart-bill/create-update-bill`;
            const today = new Date();
            const time = createdDate + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            const requestData = {
                jcJson: {
                    apiToken: CART_INITIAL_STATE.apiToken,
                    shopHash: storeActiveShopHash.id,
                    saveBill: saveBill,
                    columnList: columnList,
                    billNo: billNo,
                    createdAt: time,
                    ...paymentDetails,
                    ...customerData,
                    billStatus: saveBill ? BillStatus.INITIATED : BillStatus.PAID,
                    v2: true,
                }
            }
            const response = await snpAxios.post(billUrl, requestData);
            printDebugLog("initiatePayment", requestData.jcJson, response);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                baseRaiseInvoiceClicked(storeApiUrl.BACKEND_BASE_URL, CART_INITIAL_STATE.apiToken, storeActiveShopHash.id, payLoad.custprint, "", isMobile, payLoad.billNo, fireSnackBarMsg);
                setBillNo(payLoad.billNo);
                if (!saveBill) {
                    setIsPaid(true);
                }
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("initiatePayment error : ", error);
            setSnpLoader(false);
        }
    };

    const printBill = async (mShop) => {
        try {
            setSnpLoader(true);
            const billUrl = `${storeApiUrl.BACKEND_BASE_URL}mart-bill/print_bill/${CART_INITIAL_STATE.apiToken}/${billNo}/${storeActiveShopHash.id}/${mShop}`;
            const response = await axios.get(billUrl, {});
            printDebugLog("printBill", mShop, response);
            if (response.data !== '') {
                baseRaiseInvoiceClicked(storeApiUrl.BACKEND_BASE_URL, CART_INITIAL_STATE.apiToken, storeActiveShopHash.id, response.data, mShop === 1 ? "shop" : "cust", isMobile, billNo, fireSnackBarMsg);
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("printBill error : ", error);
            setSnpLoader(false);
        }
    }

    const handleSearch = useCallback(() => {
        printDebugLog("handleSearch:", { defaultId, searchText });
        getStockDetails(searchText);
    }, [defaultId, searchText]);


    const handleProductSearch = (value) => {
        if (value.length >= 3) {
            getProductDetails(value);
        }
    }

    const handleUpdateStockDetails = (ev, option) => {
        if (option != null) {
            setListStock([]);
            printDebugLog("handleUpdateStockDetails:", option);
            if (option.noStock) {
                fireSnackBarMsgWithColor("No Stock available for " + option.details, "#e41e2e");
            } else {
                getStockDetails(option.id);
            }
        }
    };


    const updateColumnBasedOnAssociateBenefits = async (mUseAssociateBenefits) => {
        if (columnList.length > 0) {
            printInfoLog("updateColumnBasedOnAssociateBenefits init");
            const usedBenefits = mUseAssociateBenefits ? 1 : 0;
            const updatedColumnListData = [];
            let mainSubTotal = 0.0;
            let mainCgstAmt = 0.0;
            let mainSgstAmt = 0.0;
            let mainOfferApplied = 0.0;
            let mainGrandTotal = 0.0;
            let error = false;
            for (const map of columnList) {
                if (!map.combo) {
                    setSnpLoader(true);
                    try {
                        const stock = map.choosePrices === ChooseItemPrices.Customer_Prices ?
                            map.prdId : map.lastStockRefNo;
                        const mUrl = `${storeApiUrl.BACKEND_BASE_URL}mart-bill/get-stock-rate-card-based-price-unit-v2?shopHash=${storeActiveShopHash.id}&priceIndex=${map.choosePrices}&usedBenefits=${usedBenefits}&unit=${map.unit}&stock=${stock}`;
                        const response = await snpAxios.get(mUrl);
                        if (response.data.status === SUCCESS) {
                            const payLoad = response.data.jcJson;
                            const copyMap = { ...map };
                            copyMap.price = payLoad.price;
                            const subTotalPrice = parseFloat(payLoad.price) * copyMap.quantity;
                            const finalPrice = parseFloat(payLoad.finalSp) * copyMap.quantity;
                            const parsedCgstAmt = (parseFloat(payLoad.cgstAmt) * copyMap.quantity);
                            const parsedSgstAmt = (parseFloat(payLoad.sgstAmt) * copyMap.quantity);
                            const parsedAppliedOfferAmt = (parseFloat(payLoad.appliedOfferAmt) * copyMap.quantity);
                            copyMap.subTotalPrice = subTotalPrice;
                            copyMap.finalPrice = finalPrice;
                            copyMap.cgstAmt = parsedCgstAmt;
                            copyMap.sgstAmt = parsedSgstAmt;
                            copyMap.offerAmt = parseFloat(payLoad.offerAmt);
                            copyMap.offerDenom = Number(payLoad.offerDenom);
                            copyMap.appliedOfferAmt = parsedAppliedOfferAmt;
                            copyMap.initialOrder = {
                                subTotalPrice: parseFloat(payLoad.price),
                                finalPrice: parseFloat(payLoad.finalSp),
                                cgstAmt: parseFloat(payLoad.cgstAmt),
                                sgstAmt: parseFloat(payLoad.sgstAmt),
                                appliedOfferAmt: parseFloat(payLoad.appliedOfferAmt)
                            };
                            updatedColumnListData.push(copyMap);
                            mainSubTotal += subTotalPrice;
                            mainCgstAmt += parsedCgstAmt;
                            mainSgstAmt += parsedSgstAmt;
                            mainOfferApplied += parsedAppliedOfferAmt;
                            mainGrandTotal += finalPrice;
                        } else {
                            setSnpLoader(false);
                            error = true;
                            console.error("updateColumnBasedOnAssociateBenefits response error", map, response.data);
                            setSnpComponent((prevState) => ({
                                ...prevState,
                                negativeReq: true,
                                negativeAction: "Dismiss",
                                positiveReq: true,
                                positiveAction: "Try again",
                                showDialog: true,
                                outSideClickDismiss: true,
                                cancelExtra: true,
                                requestType: 99,
                                iconContent: <WarningIcon style={{ color: "#cc0033", fontSize: "40px" }} />,
                                handleSnpSubmit: () => {
                                    setSnpComponent(INITIAL_SNP_COMPONENT);
                                    updateColumnBasedOnAssociateBenefits(mUseAssociateBenefits);
                                },
                                handleSnpCancel: () => {
                                    setSnpComponent(INITIAL_SNP_COMPONENT);
                                    setCustomerData((prev) => ({
                                        ...prev,
                                        useAssociateBenefit: !mUseAssociateBenefits,
                                    }))
                                },
                                title: "Failed!",
                                subTitle: "Error response : " + response.data.status + "-" + response.data.errorMessage,
                            }));
                            //Show error dialog
                            break;
                        }
                    } catch (error) {
                        //Show error dialog
                        error = true;
                        console.error("updateColumnBasedOnAssociateBenefits ", map, error);
                        setSnpLoader(false);
                        setSnpComponent((prevState) => ({
                            ...prevState,
                            negativeReq: true,
                            negativeAction: "Dismiss",
                            positiveReq: true,
                            positiveAction: "Try again",
                            showDialog: true,
                            outSideClickDismiss: true,
                            cancelExtra: true,
                            requestType: 99,
                            iconContent: <WarningIcon style={{ color: "#cc0033", fontSize: "40px" }} />,
                            handleSnpSubmit: () => {
                                setSnpComponent(INITIAL_SNP_COMPONENT);
                                updateColumnBasedOnAssociateBenefits(mUseAssociateBenefits);
                            },
                            handleSnpCancel: () => {
                                setSnpComponent(INITIAL_SNP_COMPONENT);
                                setCustomerData((prev) => ({
                                    ...prev,
                                    useAssociateBenefit: !mUseAssociateBenefits,
                                }))
                            },
                            title: "Failed!",
                            subTitle: test_environment_mode ? "Error: " + error : "Network Error Try again",
                        }));
                    }
                } else {
                    printDebugLog("updateColumnBasedOnAssociateBenefits ignored", map);
                    updatedColumnListData.push(map);
                    mainSubTotal += parseFloat(map.subTotalPrice);
                    mainCgstAmt += parseFloat(map.cgstAmt);
                    mainSgstAmt += parseFloat(map.sgstAmt);
                    mainOfferApplied += parseFloat(map.appliedOfferAmt);
                    mainGrandTotal += parseFloat(map.finalPrice);
                }
            }
            if (!error) {
                const mainOfferDenom = Number(paymentDetails.offerDenom);
                const mainOfferAmt = parseFloat(paymentDetails.offerAmt) || 0.0;
                const mTotalBeforeOffer = mainGrandTotal;
                const mainTotalOfferApplied = mainOfferAmt + mainOfferApplied;
                switch (parseInt(mainOfferDenom)) {
                    case OfferType.Flat:
                        mainGrandTotal = mainGrandTotal - mainOfferAmt;
                        break;
                    case OfferType.Percentage:
                        mainGrandTotal = mainGrandTotal - (mainGrandTotal * mainOfferAmt) / 100;
                        break;
                    default:
                        break;
                }
                const mRoundOff = mainGrandTotal.toFixed() - mainGrandTotal;
                mainGrandTotal = mainGrandTotal + mRoundOff;
                setPaymentDetails({
                    ...paymentDetails,
                    // totalItem:totalItem,
                    subTotal: mainSubTotal,
                    cgstAmt: mainCgstAmt,
                    sgstAmt: mainSgstAmt,
                    totalOfferApplied: mainTotalOfferApplied,
                    offerDenom: mainOfferDenom,
                    offerAmt: mainOfferAmt,
                    total: mainGrandTotal,
                    cashPay: 0.0,
                    onlinePay: 0.0,
                    onlinePayThrough: "",
                    cashReturn: 0.0,
                    cashTender: 0.0,
                    walletAmt: mUseAssociateBenefits ? mainGrandTotal : 0.0,
                    payMedium: mUseAssociateBenefits ? PayMedium.ASSOCIATE_WALLET : PayMedium.NOPAY,
                    roundOff: mRoundOff,
                    isCashPayEnabled: false,
                    isOnlinePayEnabled: false,
                    totalBeforeOffer: mTotalBeforeOffer,
                });
                setSnpLoader(false);
                setColumnList(updatedColumnListData);
                printInfoLog("updateColumnBasedOnAssociateBenefits end");
            } else {
                printInfoLog("updateColumnBasedOnAssociateBenefits nothing found");
            }
        }
    }


    const doTotal = useCallback(
        (countOperation = 1 /*Add 1 ,del 2 else any*/,
            pData = { cgstAmt: 0.0, sgstAmt: 0.0, appliedOfferAmt: 0.0, price: 0.0, sp: 0.0 } /*Previous Price of item */,
            data = { cgstAmt: 0.0, sgstAmt: 0.0, appliedOfferAmt: 0.0, price: 0.0, sp: 0.0 }/*New Price of item */,
            m_OfferDenom = OfferType.No_Offer, m_OfferAmt = 0.0,
        ) => {
            printDebugLog("doTotal init", countOperation, pData, data, m_OfferDenom, m_OfferAmt, paymentDetails);
            // let totalItem = paymentDetails.totalItem;
            // if (countOperation === 1) {
            //     totalItem = totalItem + 1;
            // } else if (countOperation === 2) {
            //     totalItem = totalItem - 1;
            // }
            let parsedOfferAmt = parseFloat(m_OfferAmt) || 0.0;
            const subTotal = parseFloat(paymentDetails.subTotal) + parseFloat(data.price) - parseFloat(pData.price); //price is MRP
            const cgstAmt = parseFloat(paymentDetails.cgstAmt) + parseFloat(data.cgstAmt) - parseFloat(pData.cgstAmt);
            const sgstAmt = parseFloat(paymentDetails.sgstAmt) + parseFloat(data.sgstAmt) - parseFloat(pData.sgstAmt);
            //mTotalBeforeOffer  is before External but contains internal item offer
            const mTotalBeforeOffer = parseFloat(paymentDetails.totalBeforeOffer) + parseFloat(data.sp) - parseFloat(pData.sp);
            let totalPrice = mTotalBeforeOffer;
            switch (parseInt(m_OfferDenom)) {
                case OfferType.Flat:
                    totalPrice = totalPrice - parsedOfferAmt;
                    break;
                case OfferType.Percentage:
                    totalPrice = totalPrice - (totalPrice * parsedOfferAmt) / 100;
                    break;
                default:
                    parsedOfferAmt = 0.0;
                    break;
            }
            const parsedtotalOfferApplied = parseFloat(paymentDetails.totalOfferApplied) || 0.0;
            const parsedAppliedOfferAmt = parseFloat(data.appliedOfferAmt) || 0.0;
            const parsedPAppliedOfferAmt = parseFloat(pData.appliedOfferAmt) || 0.0;
            const totalOfferApplied = Number(parsedtotalOfferApplied) + Number(parsedAppliedOfferAmt) - Number(parsedPAppliedOfferAmt);
            const mRoundOff = totalPrice.toFixed() - totalPrice;
            totalPrice = totalPrice + mRoundOff;
            printDebugLog("doTotal mid", paymentDetails);
            printDebugLog("doTotal end", subTotal, cgstAmt, sgstAmt, totalOfferApplied, m_OfferDenom, m_OfferAmt, mRoundOff, totalPrice);
            setPaymentDetails({
                ...paymentDetails,
                // totalItem:totalItem,
                subTotal: subTotal,
                cgstAmt: cgstAmt,
                sgstAmt: sgstAmt,
                totalOfferApplied: totalOfferApplied,
                offerDenom: m_OfferDenom,
                offerAmt: m_OfferDenom === OfferType.No_Offer ? 0 : m_OfferAmt,
                total: totalPrice,
                cashPay: 0.0,
                onlinePay: 0.0,
                onlinePayThrough: "",
                cashReturn: 0.0,
                cashTender: 0.0,
                payMedium: PayMedium.NOPAY,
                roundOff: mRoundOff,
                isCashPayEnabled: false,
                isOnlinePayEnabled: false,
                totalBeforeOffer: mTotalBeforeOffer,
            })
        }, [paymentDetails]);

    const doTotalAdd = useCallback(
        (data = { cgstAmt: 0.0, sgstAmt: 0.0, appliedOfferAmt: 0.0, price: 0.0 }) => {
            doTotal(1/* Add */,
                { cgstAmt: 0.0, sgstAmt: 0.0, appliedOfferAmt: 0.0, price: 0.0, sp: 0.0, },
                data,
                paymentDetails.offerDenom, paymentDetails.offerAmt
            );
        }, [paymentDetails, doTotal]
    );

    const doTotalDel = useCallback((pData = { cgstAmt: 0.0, sgstAmt: 0.0, appliedOfferAmt: 0.0, price: 0.0 }) => {
        doTotal(2/* Del */,
            pData,
            { cgstAmt: 0.0, sgstAmt: 0.0, appliedOfferAmt: 0.0, price: 0.0, sp: 0.0, },
            paymentDetails.offerDenom, paymentDetails.offerAmt
        );
    }, [paymentDetails, doTotal])


    const handleItemDialogClose = () => {
        setItemDetails(INITIAL_ITEM_DETAILS);
        setUnit(INITIAL_UNIT);
        setComboExist(false);
        setItemMgmt(INITIAL_ITEM_MGMT);
        setStockInfos([]);
        setSelectedStockMap(new Map());
        setChoosePrice(configChoosePrice);
        setChooseUnit("");
        setShowItemDialog(false);
        setItemQuantity(1);
        setSearchText("");
        setLastStockSelected("");
        setSelItemIndex(-1);
        setEditClick(false);
        setQuanChangeBlock(false);
    };

    const handleComboDialogClose = () => {
        setComboDetails(INITIAL_COMBO_DETAILS);
        setStockInfos([]);
        setComboDialog(false);
        setItemQuantity(1);
        setSelItemIndex(-1);
    };

    const handleDeleteItem = (cellData) => {
        const {
            sgstAmt: pItemSgstAmt,
            cgstAmt: pItemCgstAmt,
            appliedOfferAmt: pItemAppliedOfferAmt,
            subTotalPrice: pItemSubTotalPrice,
            finalPrice: pItemFinalPrice
        } = cellData;
        doTotalDel({ cgstAmt: pItemCgstAmt, sgstAmt: pItemSgstAmt, appliedOfferAmt: pItemAppliedOfferAmt, price: pItemSubTotalPrice, sp: pItemFinalPrice });
        setColumnList(prevs => prevs.filter(singleValue => singleValue.itemIndex !== cellData.itemIndex));
    }

    const handleCellClick = useCallback((field, cellData) => {
        printDebugLog("handleCellClick", cellData);
        if (field === 'del') {
            handleDeleteItem(cellData);
        } else {
            setEditClick(true);
            // if (cellData.choosePrices === ChooseItemPrices.Customer_Prices) {
            //     getMainStockDetails(SearchOption.SEARCHBYPRODN,cellData.prdId,-1);
            // } else {
            //     getMainStockDetails(SearchOption.SEARCHBYPRODN,cellData.prdId,cellData.itemIndex);
            // }
            if (cellData.combo) {
                getComboMgmt(cellData.prdId, SearchOption.SEARCHBYCOMBO, cellData.itemIndex);
            } else {
                getMainStockDetails(SearchOption.SEARCHBYPRODN, cellData.prdId, cellData.itemIndex);
            }
        }
    }, [paymentDetails, doTotal, columnList, setSelItemIndex]);




    const checkExistItemInColumn = (payLoad, filteredColumns) => {
        let localItemIndex = -1;
        let localStockRefNo = new Map();
        let localChoosePrices = configChoosePrice;
        let localUnitName = "";
        let localQuantity = 0;
        let lastStockSelected = "";
        if (filteredColumns.length === 1) {
            const item = filteredColumns[0];
            const hasMatchingStock = payLoad.stockInfos.some(stock =>
                Object.keys(item.stockRefNo).includes(stock.stockRefNo)
            );
            if (hasMatchingStock) {
                localItemIndex = item.itemIndex;
                localStockRefNo = new Map(Object.entries(item.stockRefNo));
                localChoosePrices = item.choosePrices;
                localUnitName = item.unit;
                localQuantity = item.quantity;
                lastStockSelected = item.lastStockRefNo;
            }
        } else if (filteredColumns.length > 1) {
            let hasMatchingStock = false;
            const filteredColumnsMatched = [];
            filteredColumns.forEach(col => {
                const parsedStockRefNo = new Map(Object.entries(col.stockRefNo));
                const matchingStock = payLoad.stockInfos.some(stock => parsedStockRefNo.has(stock.stockRefNo));
                if (matchingStock) {
                    hasMatchingStock = matchingStock;
                    filteredColumnsMatched.push(col);
                    parsedStockRefNo.forEach((value, key) => {
                        localStockRefNo.set(key, value);
                    });
                }
            });
            if (hasMatchingStock) {

                const uniqueChoosePrices = new Set(filteredColumnsMatched.map(col => col.choosePrices));
                localChoosePrices = uniqueChoosePrices.size === 1 ? [...uniqueChoosePrices][0] : configChoosePrice;

                // 3. Update unit
                const uniqueUnits = new Set(filteredColumnsMatched.map(col => col.unit));
                localUnitName = uniqueUnits.size === 1 ? [...uniqueUnits][0] : payLoad.cnvMap.unitName;

                // 4. Update quantity (sum of all quantities)
                for (const value of localStockRefNo.values()) {
                    const extractedValue = uiUtilInstance.getMatchedQuan(value);
                    localQuantity += extractedValue;
                }
                if (payLoad.stockInfos.length === 1) {
                    const stockNoToFind = payLoad.stockInfos[0].stockRefNo;
                    const matchedItem = filteredColumnsMatched.find(col =>
                        new Map(Object.entries(col.stockRefNo)).has(stockNoToFind)
                    );

                    if (matchedItem) {
                        localItemIndex = matchedItem.itemIndex;
                        lastStockSelected = matchedItem.lastStockRefNo;
                    }
                } else {
                    setQuanChangeBlock(true);
                }
            }
        }
        if (localQuantity === 0) {
            localQuantity = 1;
        }
        return { localItemIndex, localStockRefNo, localChoosePrices, localUnitName, localQuantity, lastStockSelected };
    };

    const addorUpdateItem = (payLoad, mItemIndex) => {
        let localItemIndex = -1;
        let localStockRefNo = null;
        let localChoosePrices = configChoosePrice;
        let localUnitName = "";
        let localQuantity = 1;
        let lastStockSelected = "";
        const cnvMap = payLoad.cnvMap;
        const mStockInfos = payLoad.stockInfos;

        if (columnList.length > 0) {
            const mPrdId = payLoad.itemDetails.prdId;
            const filteredColumns = columnList.filter(col => col.prdId === mPrdId);
            if (filteredColumns.length > 0) {
                //search by Barcode/batch then after getting data look the existing prdId and show only those with that much quantity & details
                //custom Barcode , only that details & that much quantity
                //Search via Product then so all the items in column with block feature for quantity change
                if (mItemIndex !== -1) {
                    const item = getColumnByItemIndex(columnList, mItemIndex);
                    localItemIndex = mItemIndex;
                    localChoosePrices = item.choosePrices;
                    localStockRefNo = new Map(Object.entries(item.stockRefNo));
                    localUnitName = item.unit;
                    localQuantity = item.quantity;
                    lastStockSelected = item.lastStockRefNo;
                } else {
                    const result = checkExistItemInColumn(payLoad, filteredColumns);
                    localItemIndex = result.localItemIndex;
                    localStockRefNo = result.localStockRefNo;
                    localChoosePrices = result.localChoosePrices;
                    localUnitName = result.localUnitName;
                    localQuantity = result.localQuantity;
                    lastStockSelected = result.lastStockSelected;
                }
            }
        }
        if (cnvMap.unitRestrictions && mStockInfos.length === 1 && mItemIndex === -1) {
            //Handle Directly Add Item here
            const item = mStockInfos[0];
            if (localItemIndex > -1) {
                localQuantity += 1;
            }
            if (localStockRefNo == null) {
                localStockRefNo = new Map();
            }
            localUnitName = cnvMap.unitName;
            localStockRefNo.set(item.stockRefNo, localUnitName + "=" + localQuantity);
            handleBaseAddItem(item, localChoosePrices, localUnitName, localQuantity,
                localStockRefNo, localItemIndex, payLoad.itemDetails, payLoad.management, cnvMap, columnList);
            showItemDialog(false);
        } else {
            setItemDetails(payLoad.itemDetails);
            setUnit(cnvMap);
            setLastStockSelected(lastStockSelected);
            setItemMgmt(payLoad.management);
            setComboExist(payLoad.comboExist);
            setSelItemIndex(localItemIndex);
            setSelectedStockMap(localStockRefNo == null ? new Map() : localStockRefNo);
            setChoosePrice(localChoosePrices);
            setChooseUnit(isEmpty(localUnitName) ? cnvMap.unitName : localUnitName);
            setItemQuantity(localQuantity);
            setStockInfos(mStockInfos);
            setShowItemDialog(true);
        }
    };



    const updateColumList = (data, index) => {
        printDebugLog("updateColumList", data, index);
        if (index !== -1) {
            setColumnList(prevList =>
                prevList.map((item, idx) => (idx === index ? data : item))
            );
        } else {
            setColumnList([...columnList, data]);
        }
    };



    const preCheck = (incQuan, data) => {
        if (incQuan > data.remQuan) {
            if (incQuan <= data.totalQuan) {
                handleCellClick("edit", data);
            } else {
                fireSnackBarMsgWithColor("Exceeds Total Count for  " + data.unit + " is " + data.remQuan, "#e41e2e");
            }
            return true;
        }
        return false;
    }

    const handleIncrement = useCallback(async (cellData) => {
        printDebugLog("handleIncrement", cellData);
        if (isBillLocked) {
            fireSnackBarMsg("This bill is locked and cannot be edited");
            return;
        }
        const {
            prdId: pPrdId,
            sgstAmt: pItemSgstAmt,
            cgstAmt: pItemCgstAmt,
            appliedOfferAmt: pItemAppliedOfferAmt,
            subTotalPrice: pItemSubTotalPrice,
            finalPrice: pItemFinalPrice,
            stockRefNo: pStockRefNo,
            unit: pChooseUnit,
            lastStockRefNo: plastStockRefNo,
            choosePrices: pChoosePrice,
        } = cellData;
        const mapStockRefNo = new Map(Object.entries(pStockRefNo));
        if (mapStockRefNo.size > 1 && !cellData.combo) {
            fireSnackBarMsg("Multiple stocks are selected. Cannot increment.Click Edit");
            return;
        }
        const mQuantity = cellData.quantity + 1;
        if (preCheck(mQuantity, cellData)) {
            return;
        }

        let parsedCgstAmt = 0.0;
        let parsedSgstAmt = 0.0;
        if (cellData.combo) {
            parsedCgstAmt = pItemCgstAmt + Number(cellData.initialOrder.cgstAmt);
            parsedSgstAmt = pItemSgstAmt + Number(cellData.initialOrder.sgstAmt);
        } else {
            const stock = pChoosePrice === ChooseItemPrices.Customer_Prices ? pPrdId : plastStockRefNo;
            const result = await getStockGstPricesBasedOnPricenUnit(pChoosePrice, pChooseUnit, customerData.useAssociateBenefit, stock);
            printDebugLog("getStockGstPricesBasedOnPricenUnit ", result);
            if (result && result.status === SUCCESS) {
                parsedCgstAmt = pItemCgstAmt + Number(result.jcJson.cgstAmt);
                parsedSgstAmt = pItemSgstAmt + Number(result.jcJson.sgstAmt);
            }
        }


        const mapValue = pChooseUnit + "=" + mQuantity;
        mapStockRefNo.set(plastStockRefNo, mapValue);
        const jsonMapString = Object.fromEntries(mapStockRefNo);
        const item = {
            ...cellData,
            quantity: mQuantity,
            subTotalPrice: parseFloat(cellData.price) * mQuantity,
            cgstAmt: parsedCgstAmt,
            sgstAmt: parsedSgstAmt,
            finalPrice: parseFloat(cellData.initialOrder.finalPrice) * mQuantity,
            stockRefNo: jsonMapString,
            appliedOfferAmt: parseFloat(cellData.initialOrder.appliedOfferAmt) * mQuantity
        };

        doTotal(3/* Edit */,
            { cgstAmt: pItemCgstAmt, sgstAmt: pItemSgstAmt, appliedOfferAmt: pItemAppliedOfferAmt, price: pItemSubTotalPrice, sp: pItemFinalPrice },
            { cgstAmt: item.cgstAmt, sgstAmt: item.sgstAmt, appliedOfferAmt: item.appliedOfferAmt, price: item.subTotalPrice, sp: item.finalPrice },
            paymentDetails.offerDenom, paymentDetails.offerAmt
        );
        const index = columnList.findIndex(singleValue => singleValue.itemIndex === cellData.itemIndex);
        updateColumList(item, index);
    }, [paymentDetails, customerData, comboDetails, columnList, doTotal, isBillLocked]);

    const handleDecrement = useCallback(async (cellData) => {
        printDebugLog("handleDecrement", cellData);
        if (isBillLocked) {
            fireSnackBarMsg("This bill is locked and cannot be edited");
            return;
        }
        const {
            prdId: pPrdId,
            sgstAmt: pItemSgstAmt,
            cgstAmt: pItemCgstAmt,
            appliedOfferAmt: pItemAppliedOfferAmt,
            subTotalPrice: pItemSubTotalPrice,
            finalPrice: pItemFinalPrice,
            stockRefNo: pStockRefNo,
            unit: pChooseUnit,
            lastStockRefNo: plastStockRefNo,
            choosePrices: pChoosePrice,
        } = cellData;
        const mapStockRefNo = new Map(Object.entries(pStockRefNo));
        if (mapStockRefNo.size > 1 && !cellData.combo) {
            fireSnackBarMsg("Multiple stocks are selected. Cannot decrement.Click Edit");
            return;
        }
        const mQuantity = cellData.quantity - 1;
        if (mQuantity > 0) {

            let parsedCgstAmt = 0.0;
            let parsedSgstAmt = 0.0;
            if (cellData.combo) {
                parsedCgstAmt = pItemCgstAmt - Number(cellData.initialOrder.cgstAmt);
                parsedSgstAmt = pItemSgstAmt - Number(cellData.initialOrder.sgstAmt);
            } else {
                const stock = pChoosePrice === ChooseItemPrices.Customer_Prices ? pPrdId : plastStockRefNo;
                const result = await getStockGstPricesBasedOnPricenUnit(pChoosePrice, pChooseUnit, customerData.useAssociateBenefit, stock);
                printDebugLog("getStockGstPricesBasedOnPricenUnit ", result);
                if (result && result.status === SUCCESS) {
                    parsedCgstAmt = pItemCgstAmt - Number(result.jcJson.cgstAmt);
                    parsedSgstAmt = pItemSgstAmt - Number(result.jcJson.sgstAmt);
                }
            }
            const mapValue = pChooseUnit + "=" + mQuantity;
            mapStockRefNo.set(plastStockRefNo, mapValue);
            const jsonMapString = Object.fromEntries(mapStockRefNo);
            const item = {
                ...cellData,
                quantity: mQuantity,
                subTotalPrice: parseFloat(cellData.price) * mQuantity,
                cgstAmt: parsedCgstAmt,
                sgstAmt: parsedSgstAmt,
                finalPrice: parseFloat(cellData.initialOrder.finalPrice) * mQuantity,
                stockRefNo: jsonMapString,
                appliedOfferAmt: parseFloat(cellData.initialOrder.appliedOfferAmt) * mQuantity
            };

            doTotal(3/* Edit */,
                { cgstAmt: pItemCgstAmt, sgstAmt: pItemSgstAmt, appliedOfferAmt: pItemAppliedOfferAmt, price: pItemSubTotalPrice, sp: pItemFinalPrice },
                { cgstAmt: item.cgstAmt, sgstAmt: item.sgstAmt, appliedOfferAmt: item.appliedOfferAmt, price: item.subTotalPrice, sp: item.finalPrice },
                paymentDetails.offerDenom, paymentDetails.offerAmt
            );
            const index = columnList.findIndex(singleValue => singleValue.itemIndex === cellData.itemIndex);
            updateColumList(item, index);
        }

    }, [paymentDetails, customerData, comboDetails, columnList, doTotal, isBillLocked]);



    const getTotalQuan = (singleStock, mChooseUnit, mChoosePrices) => {
        let totalQuan = 0;
        if (mChoosePrices === ChooseItemPrices.Stock_Prices) {
            totalQuan = mChooseUnit === cnvMap.unitName ? singleStock.remQuan[0] : singleStock.remQuan[1];
        } else {
            totalQuan = mChooseUnit === cnvMap.unitName ? management.totalCount[0] : management.totalCount[1];
        }
        return totalQuan;
    }

    const handleBaseUpdateCombo = (mComboData, index, mQuantity) => {
        if (mQuantity > -1) {
            const mapStockRefNo = new Map(Object.entries(mComboData.stockRefNo)); //Always Initial
            const matchedItem = index > -1 ? getColumnByItemIndex(columnList, index) : null;
            mapStockRefNo.forEach((value, key) => {
                const unitSplitter = value.split("=");
                const extractedValue = Number(unitSplitter[1]) * mQuantity;
                mapStockRefNo.set(key, unitSplitter[0] + "=" + extractedValue);
            });
            const parsedCgstAmt = Number(mComboData.totalCgstAmt) * mQuantity;
            const parsedSgstAmt = Number(mComboData.totalSgstAmt) * mQuantity;
            const subTotalPrice = Number(mComboData.price) * mQuantity;
            const finalPrice = Number(mComboData.subTotalPrice) * mQuantity;
            const parsedAppliedOfferAmt = (Number(mComboData.appliedOfferAmt) * mQuantity).toFixed(2);
            const jsonMapString = Object.fromEntries(mapStockRefNo);
            const mItemIndex = index > -1 ? matchedItem.itemIndex : columnList.length;
            const initialOrder = { subTotalPrice: mComboData.price, finalPrice: mComboData.subTotalPrice, cgstAmt: mComboData.totalCgstAmt, sgstAmt: mComboData.totalSgstAmt, appliedOfferAmt: mComboData.appliedOfferAmt };
            const item = {
                itemIndex: mItemIndex,
                name: mComboData.name,
                prdId: mComboData.prdId,
                unit: mComboData.unit,
                decimalSmRestrictions: true,
                choosePrices: mComboData.choosePrices,
                stockRefNo: jsonMapString,
                quantity: mQuantity,
                price: mComboData.price,
                hsn: "",
                listBatch: mComboData.listBatch,
                listBarCode: mComboData.listBarCode,
                offerDenom: mComboData.offerDenom,
                offerAmt: mComboData.offerAmt,
                subTotalPrice: subTotalPrice,
                finalPrice: finalPrice,
                combo: true,
                cgst: 0,
                sgst: 0,
                cgstAmt: parsedCgstAmt,
                sgstAmt: parsedSgstAmt,
                appliedOfferAmt: parsedAppliedOfferAmt,
                initialOrder: initialOrder,
            }
            updateColumList(item, index);
            if (index !== -1) {
                const {
                    sgstAmt: pItemSgstAmt,
                    cgstAmt: pItemCgstAmt,
                    appliedOfferAmt: pItemAppliedOfferAmt,
                    subTotalPrice: pItemSubTotalPrice,
                    finalPrice: pItemFinalPrice
                } = matchedItem;
                doTotal(3/* Edit */,
                    { cgstAmt: pItemCgstAmt, sgstAmt: pItemSgstAmt, appliedOfferAmt: pItemAppliedOfferAmt, price: pItemSubTotalPrice, sp: pItemFinalPrice },
                    { cgstAmt: item.cgstAmt, sgstAmt: item.sgstAmt, appliedOfferAmt: item.appliedOfferAmt, price: item.subTotalPrice, sp: item.finalPrice },
                    paymentDetails.offerDenom, paymentDetails.offerAmt
                );
            } else {
                doTotalAdd({
                    cgstAmt: item.cgstAmt, sgstAmt: item.sgstAmt,
                    appliedOfferAmt: item.appliedOfferAmt, price: item.subTotalPrice, sp: item.finalPrice
                }
                );
            }

            fireSnackBarMsg(index !== -1 ? "Item " + mComboData.name + " updated successfully" : "Item " + mComboData.name + " added successfully");
        }
    }

    const quantityCheckBeforeAdd = (singleStock, mCnvMap, chooseUnit, mapStockRefNo) => {
        const value = mapStockRefNo.get(singleStock.stockRefNo);
        const mQuantity = uiUtilInstance.getMatchedQuan(value, 0);
        const remQuantityInStock = chooseUnit === mCnvMap.unitName ? singleStock.remQuan[0] : singleStock.remQuan[1];
        if (mQuantity > remQuantityInStock) {
            fireSnackBarMsgWithColor("Exceeds Total Count i.e  " + remQuantityInStock + " " + chooseUnit, "#e41e2e");
            return;
        }
    }

    const baseAddUpdateItem = (singleStock, choosePrices, chooseUnit, mQuantity, mapStockRefNo, index, mItemDetails, mManagement, mCnvMap
        , updatedCgstAmt, updatedSgstAmt, mColumnList
    ) => {
        quantityCheckBeforeAdd(singleStock, mCnvMap, chooseUnit, mapStockRefNo);
        const { price, offerDenom, offerAmt, finalSp, cgst, sgst, cgstAmt, sgstAmt, appliedOfferAmt }
            = baseColumnRateCard(singleStock, choosePrices, chooseUnit, mManagement, mCnvMap, customerData.useAssociateBenefit);
        const mChooseUnit = chooseUnit === mCnvMap.unitName ? SearchOption.SELECTEDBIGPRICE : SearchOption.SELECTEDSMALLPRICE;

        printDebugLog("baseAddUpdateItem", mapStockRefNo, singleStock, choosePrices, mChooseUnit, index, chooseUnit, mQuantity, updatedCgstAmt, updatedSgstAmt, mColumnList);
        const subTotalPrice = parseFloat(price) * mQuantity;
        const finalPrice = parseFloat(finalSp) * mQuantity;
        const parsedAppliedOfferAmt = (parseFloat(appliedOfferAmt) * mQuantity).toFixed(2);
        const lastStockRefNo = singleStock.stockRefNo;
        const jsonMapString = Object.fromEntries(mapStockRefNo);
        const matchedItem = index > -1 ? getColumnByItemIndex(columnList, index) : null;

        const parsedCgstAmt = updatedCgstAmt > -1 ? updatedCgstAmt : index > -1 ?
            Number(matchedItem.cgstAmt) + Number(cgstAmt) : Number(cgstAmt);
        const parsedSgstAmt = updatedSgstAmt > -1 ? updatedSgstAmt : index > -1 ?
            Number(matchedItem.sgstAmt) + Number(sgstAmt) : Number(sgstAmt);

        const listBatch = index > -1
            ? Array.from(new Set([...matchedItem.listBatch, singleStock.batchNo]))
            : [singleStock.batchNo];
        const listBarCode = index > -1
            ? Array.from(new Set([...matchedItem.listBarCode, singleStock.barCode]))
            : [singleStock.barCode];
        const columnLastItemIndex = mColumnList[mColumnList.length - 1]?.itemIndex ?? -1;
        printDebugLog("columnLastItemIndex ", mColumnList.length, columnLastItemIndex);
        const mItemIndex = index > -1 ? matchedItem.itemIndex : (columnLastItemIndex + 1);
        const item = {
            itemIndex: mItemIndex,
            name: mItemDetails.name,
            prdId: mItemDetails.prdId,
            unit: chooseUnit,
            decimalSmRestrictions: mCnvMap.decimalSmRestrictions,
            choosePrices: choosePrices,
            stockRefNo: jsonMapString,
            lastStockRefNo: lastStockRefNo,
            quantity: mQuantity,
            price: price,
            hsn: singleStock.hsn,
            listBatch: listBatch,
            listBarCode: listBarCode,
            offerDenom: offerDenom,
            offerAmt: offerAmt,
            subTotalPrice: subTotalPrice,
            finalPrice: finalPrice,
            combo: false,
            cgst: cgst,
            sgst: sgst,
            smallUnitCount: mCnvMap.smallUnitCount,
            chooseUnit: mChooseUnit,
            remQuan: chooseUnit === mCnvMap.unitName ? singleStock.remQuan[0] : singleStock.remQuan[1],
            totalQuan: getTotalQuan(singleStock, chooseUnit, choosePrices),
            cgstAmt: parsedCgstAmt,
            sgstAmt: parsedSgstAmt,
            appliedOfferAmt: parsedAppliedOfferAmt,

            initialOrder: { subTotalPrice: price, finalPrice: finalSp, cgstAmt: cgstAmt, sgstAmt: sgstAmt, appliedOfferAmt: appliedOfferAmt },
        }
        updateColumList(item, index);
        if (index !== -1) {
            const {
                sgstAmt: pItemSgstAmt,
                cgstAmt: pItemCgstAmt,
                appliedOfferAmt: pItemAppliedOfferAmt,
                subTotalPrice: pItemSubTotalPrice,
                finalPrice: pItemFinalPrice
            } = matchedItem;
            doTotal(3/* Edit */,
                { cgstAmt: pItemCgstAmt, sgstAmt: pItemSgstAmt, appliedOfferAmt: pItemAppliedOfferAmt, price: pItemSubTotalPrice, sp: pItemFinalPrice },
                { cgstAmt: item.cgstAmt, sgstAmt: item.sgstAmt, appliedOfferAmt: item.appliedOfferAmt, price: item.subTotalPrice, sp: item.finalPrice },
                paymentDetails.offerDenom, paymentDetails.offerAmt
            );
        } else {
            doTotalAdd({
                cgstAmt: item.cgstAmt, sgstAmt: item.sgstAmt,
                appliedOfferAmt: item.appliedOfferAmt, price: item.subTotalPrice, sp: item.finalPrice
            }
            );
        }

        fireSnackBarMsg(index !== -1 ? "Item " + mItemDetails.name + " updated successfully" : "Item " + mItemDetails.name + " added successfully");
    };

    const handleBaseAddItem = (singleStock, choosePrices, chooseUnit, mQuantity, mapStockRefNo, index, mItemDetails, mManagement, mCnvMap, mColumnList) => {
        baseAddUpdateItem(singleStock, choosePrices, chooseUnit, mQuantity, mapStockRefNo, index, mItemDetails, mManagement, mCnvMap, -1, -1, mColumnList);
    };

    //const handleAddItem = useCallback((singleStock, choosePrices, chooseUnit,mQuantity,limits = []) => {
    const handleAddItem = useCallback((singleStock, choosePrices, chooseUnit, mQuantity, mapStockRefNo, mSelectedItemIndex) => {
        handleBaseAddItem(singleStock, choosePrices, chooseUnit,
            mQuantity, mapStockRefNo, mSelectedItemIndex, itemDetails,
            management, cnvMap, columnList);
        handleItemDialogClose();
    }, [paymentDetails, columnList, itemDetails, cnvMap, management, customerData, doTotalAdd, doTotal]);

    const handleUpdateQuantityChanges = useCallback((choosePrices, chooseUnit, mQuantity, mapStockRefNo, mSelectedItemIndex) => {
        if (mapStockRefNo.size > 0) {
            let parsedCgstAmt = 0.0;
            let parsedSgstAmt = 0.0;
            let promises = [];
            const firstEntry = mapStockRefNo.entries().next().value;
            printDebugLog("handleUpdateQuantityChanges", firstEntry);
            const singleStock = stockInfos.find(col => col.stockRefNo === firstEntry[0]);
            if (choosePrices === ChooseItemPrices.Customer_Prices) {
                promises.push(getStockGstPricesBasedOnPricenUnit(choosePrices, chooseUnit, customerData.useAssociateBenefit, singleStock.prdId));
            } else {

                mapStockRefNo.forEach((value, key) => {
                    promises.push(getStockGstPricesBasedOnPricenUnit(choosePrices, chooseUnit, customerData.useAssociateBenefit, key));
                });
            }

            Promise.all(promises)
                .then((dataArray) => {
                    dataArray.forEach((data, index) => {
                        if (data && data.status === SUCCESS) {
                            parsedCgstAmt += Number(data.jcJson.cgstAmt);
                            parsedSgstAmt += Number(data.jcJson.sgstAmt);
                        }
                    });
                })
                .catch((err) => {
                    console.error('Error in fetching data for keys:', err);
                });


            baseAddUpdateItem(singleStock, choosePrices, chooseUnit, mQuantity, mapStockRefNo, mSelectedItemIndex, itemDetails, management, cnvMap, parsedCgstAmt, parsedSgstAmt, columnList);
        } else {
            const cellData = getColumnByItemIndex(columnList, mSelectedItemIndex);
            handleDeleteItem(cellData);
        }
        handleItemDialogClose();
    }, [paymentDetails, columnList, itemDetails, stockInfos, cnvMap, management, customerData, doTotalAdd, doTotal]);

    const handleProductSelect = (selecetdItemDetails) => {
        printDebugLog("handleProductSelect", selecetdItemDetails);
        getMainStockDetails(SearchOption.SEARCHBYPRODN, selecetdItemDetails.id, -1);
    }

    const fireSnackBarMsg = (msg, mHorizontal = "right", mVertical = "top", mColor = "#008b8b") => {
        setSnpComponent(prev => ({
            ...prev,
            snackBarMsg: msg,
            snackBarOpen: true,
            snackHorizontal: mHorizontal,
            snackVertical: mVertical,
            snackColor: mColor
        }));
    };

    const fireSnackBarMsgWithColor = (mSg, mColor = "#008b8b") => {
        fireSnackBarMsg(mSg, "center", "center", mColor);
    };

    const handleClearUi = () => {
        setBillNo("");
        setCreatedDate(uiUtilInstance.todayFormattedDate);
        setColumnList([]);
        setPaymentDetails(INITIAL_PAYMENT_MODEL);
        setIsPaid(false);
        setCustomerData(INITIAL_CUSTOMER_DATA);
        setBillData({});
        setRejectionReason("");
    }

    const dataGridComponent = useMemo(() => {
        return (
            <CustomDataGrid
                getRowId={(row) => row.itemIndex}
                rows={columnList}
                columns={columns}
                mDensity="compact"
            />
        );
    }, [columnList, paymentDetails, isBillLocked]);

    const customerComponent = useMemo(() => {
        return (
            <RenderCustomerInfo
                baseUrl={storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeActiveShopHash.cartType)}
                shopHash={storeActiveShopHash.id}
                customerData={customerData}
                isPaid={isBillLocked}
                destinationAddress={billData?.destinationAddress ?? ""}
                setCustomerData={setCustomerData}
                updateColumnBasedOnAssociateBenefits={updateColumnBasedOnAssociateBenefits}
            />
        )
    }, [storeApiUrl, storeActiveShopHash, customerData, billData, isBillLocked, columnList]);

    const billInfoComponent = useMemo(() => {
        const isFullPaid = Number(paymentDetails.billStatus) === BillStatus.PAID || isPaid === true;
        const statusText = isRejected ? "(Pay Status : Rejected)"
            : isFullPaid ? "(Pay Status : Full Paid)" : "(Pay Status : Not Paid)";
        return (
            <div style={{ position: "relative" }}>
                <Box component="span" sx={{
                    position: { xs: "static", sm: "absolute" },
                    display: "block",
                    width: { xs: "100%", sm: "auto" },
                    textAlign: "center",
                    mb: { xs: 0.75, sm: 0 },
                    top: { sm: "10px" },
                    right: { sm: "12px" },
                    color: isFullPaid ? "#198754" : "#dc3545",
                    fontSize: "calc(1.5rem - 2pt)",
                    fontWeight: 700,
                    lineHeight: 1.2,
                }}>
                    {statusText}
                </Box>
                <RenderBillInfo
                    key={paymentDetails}
                    isPaid={isBillLocked}
                    paymentDetails={paymentDetails}
                    useAssociateBenefit={customerData.useAssociateBenefit}
                    setPaymentDetails={setPaymentDetails}
                    fireSnackBarMsg={fireSnackBarMsg}
                />
            </div>
        )
    }, [isPaid, isBillLocked, isRejected, paymentDetails, customerData.useAssociateBenefit]);

    const searchComponent = useMemo(() => {
        return (
            <RenderSearchChoice
                defaultId={defaultId}
                onSearch={handleSearch}
                onDefaultIdChange={setDefaultId}
                onTextChange={setSearchText}
                loader={productSearchLoader}
                listStock={listStock}
                setListStock={setListStock}
                inputValue={searchText}
                handleProductSearch={handleProductSearch}
                handleUpdateStockDetails={handleUpdateStockDetails}
            />
        )
    }, [defaultId, handleSearch, productSearchLoader, listStock, searchText]);

    const renderDialogContent = useMemo(() => {
        return (<RenderDialogContent
            key={paymentDetails}
            itemDetails={itemDetails}
            management={management}
            cnvMap={cnvMap}
            stockInfos={stockInfos}
            cartType={storeActiveShopHash.cartType}
            defChoosePrices={defChoosePrices}
            defChooseUnit={defChooseUnit}
            handleItemAdd={handleAddItem}
            defSelectedStockMap={selectedStockMap}
            defItemQuantity={itemQuantity}
            quanChangeBlock={quanChangeBlock}
            defColumnList={columnList}
            editClick={editClick}
            defSelectedItemIndex={selectedItemIndex}
            lastStockSelected={lastStockSelected}
            defListProduct={listProduct}
            handleProductSelect={handleProductSelect}
            updateQuantityChanges={handleUpdateQuantityChanges}
            fireSnackBarMsg={fireSnackBarMsgWithColor}
        />)
    }, [itemDetails, management, cnvMap, stockInfos, storeActiveShopHash, defChoosePrices, defChooseUnit, selectedStockMap, itemQuantity, quanChangeBlock, columnList, selectedItemIndex, lastStockSelected, handleAddItem]);


    const renderComboDialog = () => {
        return (<RenderComboDialog
            mComboDetails={comboDetails}
            mStockInfos={stockInfos}
            itemQuantity={itemQuantity}
            setItemQuantity={setItemQuantity}
        />)
    }

    const renderComboDialogAction = () => {
        return (
            <>
                <SnpButton variant="contained" onClick={() => {
                    handleBaseUpdateCombo(comboDetails, selectedItemIndex, itemQuantity);
                    handleComboDialogClose();
                }}>
                    Submit
                </SnpButton>
                <DismissButton variant="contained" color="primary" onClick={handleComboDialogClose}>
                    Dismiss
                </DismissButton>
            </>
        )
    };

    const renderItemDialogAction = () => {
        return (
            <DismissButton variant="contained" color="primary" onClick={handleItemDialogClose}>
                Dismiss
            </DismissButton>
        )
    };

    const dialogActionButton = () => {
        return (
            <>
                <SnpButton variant="contained" color="primary" onPointerDown={() => upateDeliveryStatus()}>
                    Update
                </SnpButton>
                <DismissButton variant="contained" color="primary" onPointerDown={() => setStatusDialog(false)}>
                    Do it later!
                </DismissButton>
            </>
        )
    }


    const renderSnpContent = () => {
        const transactionMethod = billData?.thirdParty?.method ?? "";
        const bankTransaction = billData?.thirdParty?.bank_transaction
            ?? billData?.thirdParty?.bank_transactionId
            ?? "";
        const showTransactionDetails = !isEmpty(transactionMethod) || !isEmpty(bankTransaction);

        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Paper elevation={0}
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            backgroundColor: "#dbdcff",
                            boxShadow: 1,
                            borderRadius: 5,
                            padding: 1,
                        }} >
                        <Grid container spacing={1}>
                            <RenderBillHeader
                                billNo={billNo}
                                selectedDate={createdDate}
                                handleClearEveryThing={handleClearUi}
                            />
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                {!isBillLocked && searchComponent}
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={10}>
                                {dataGridComponent}
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} sm={5} lg={4}>
                    {customerComponent}
                </Grid>
                <Grid item xs={12} md={8} sm={7} lg={8}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            {billInfoComponent}
                        </Grid>
                        <Grid item xs={12} sx={{ p: 2 }}>
                            <FormControl>
                                <EnterButton disabled={saveInitiateBillDisable}
                                    variant="contained"
                                    color="primary"
                                    aria-describedby="button-helper-text"
                                    onClick={() => initiatePayment(true)}>
                                    Save Bill
                                </EnterButton>
                                <FormHelperText sx={{ textAlign: 'center' }} id="button-helper-text">
                                    <span style={{ color: "#892024", fontWeight: "bold", fontSize: "12px" }}>Key: ctrl+s</span>
                                </FormHelperText>
                            </FormControl>
                            <FormControl>
                                <EnterButton disabled={saveInitiateBillDisable}
                                    variant="contained"
                                    color="primary"
                                    aria-describedby="button-helper-text"
                                    onClick={() => initiatePayment(false)}>
                                    Initiate Payment
                                </EnterButton>
                                <FormHelperText sx={{ textAlign: 'center' }} id="button-helper-text">
                                    <span style={{ color: "#892024", fontWeight: "bold", fontSize: "12px" }}>Key: ctrl+i</span>
                                </FormHelperText>
                            </FormControl>
                            {
                                hasOnlinePaymentReference && !isPaid && !isRejected && isOtherRoleAllowed(OTHER_ADMIN_RIGHTS) &&
                                <FormControl>
                                    <EnterButton
                                        disabled={snpLoader}
                                        variant="contained"
                                        mbgcolor="#b42318"
                                        onClick={() => setRejectDialog(true)}>
                                        Reject Bill
                                    </EnterButton>
                                    <FormHelperText sx={{ textAlign: 'center', color: '#b42318' }}>
                                        Owner action
                                    </FormHelperText>
                                </FormControl>
                            }
                            {
                                billedFrom === BillFromMachine.WEB &&
                                <FormControl>
                                    <EnterButton disabled={printBillDisable}
                                        variant="contained"
                                        mbgcolor="#180100"
                                        aria-describedby="button-helper-text"
                                        onClick={() => setStatusDialog(true)}>
                                        Update Delivery Status
                                    </EnterButton>
                                    <FormHelperText sx={{ textAlign: 'center' }} id="button-helper-text">
                                        <span style={{ color: "#892024", fontWeight: "bold", fontSize: "12px" }}>Key: ctrl+q</span>
                                    </FormHelperText>
                                </FormControl>
                            }
                            {
                                storeActiveShopHash.cartType !== CartDets.Watch &&
                                <FormControl>
                                    <EnterButton disabled={printBillDisable}
                                        variant="contained"
                                        mbgcolor="#180100"
                                        aria-describedby="button-helper-text"
                                        onClick={() => printBill(1)}>
                                        Print Shop Bill
                                    </EnterButton>
                                    <FormHelperText sx={{ textAlign: 'center' }} id="button-helper-text">
                                        <span style={{ color: "#892024", fontWeight: "bold", fontSize: "12px" }}>Key: ctrl+alt+2</span>
                                    </FormHelperText>
                                </FormControl>
                            }
                            {
                                storeActiveShopHash.cartType !== CartDets.Watch &&
                                <FormControl>
                                    <EnterButton disabled={printBillDisable}
                                        variant="contained"
                                        aria-describedby="button-helper-text"
                                        mbgcolor="#220000"
                                        onClick={() => printBill(0)}>
                                        Print Customer Bill
                                    </EnterButton>
                                    <FormHelperText sx={{ textAlign: 'center' }} id="button-helper-text">
                                        <span style={{ color: "#892024", fontWeight: "bold", fontSize: "12px" }}>Key: ctrl+alt+3</span>
                                    </FormHelperText>
                                </FormControl>
                            }
                            {
                                storeActiveShopHash.cartType === CartDets.Watch &&
                                <FormControl>
                                    <EnterButton disabled={printBillDisable}
                                        variant="contained"
                                        aria-describedby="button-helper-text"
                                        mbgcolor="#220000"
                                        onClick={() => printBill(0)}>
                                        Generate Bill
                                    </EnterButton>
                                    <FormHelperText sx={{ textAlign: 'center' }} id="button-helper-text">
                                        <span style={{ color: "#892024", fontWeight: "bold", fontSize: "12px" }}>Key: ctrl+alt+4</span>
                                    </FormHelperText>
                                </FormControl>
                            }
                        </Grid>
                    </Grid>
                </Grid>
                {showTransactionDetails && (
                    <Grid item xs={12}>
                        <Box sx={{
                            textAlign: "center",
                            fontWeight: 700,
                            textDecoration: "underline",
                            overflowWrap: "anywhere",
                        }}>
                            {!isEmpty(transactionMethod) && `Method: ${transactionMethod}`}
                            {!isEmpty(transactionMethod) && !isEmpty(bankTransaction) && " | "}
                            {!isEmpty(bankTransaction) && `Bank Transaction: ${bankTransaction}`}
                        </Box>
                    </Grid>
                )}
                {billData?.tripDetails === TRIP_DELIVERED && (
                    <Grid item xs={12}>
                        <Box sx={{
                            textAlign: "center",
                            color: "#198754",
                            fontWeight: 700,
                            textDecoration: "underline",
                        }}>
                            Delivered successfully
                        </Box>
                    </Grid>
                )}
                {isRejected && !isEmpty(billData?.reason ?? "") && (
                    <Grid item xs={12}>
                        <Box
                            onClick={() => setReasonDialog(true)}
                            role="button"
                            tabIndex={0}
                            sx={{
                                textAlign: "center",
                                color: "#b42318",
                                fontWeight: 700,
                                textDecoration: "underline",
                                overflowWrap: "anywhere",
                                cursor: "pointer",
                            }}>
                            Rejection Reason: {billData.reason}
                        </Box>
                    </Grid>
                )}
                {/* Dialog Things */}
                <DialogBox
                    showDialog={rejectDialog}
                    title="Reject Bill"
                    onClose={() => setRejectDialog(false)}
                    outsideClickedDismiss={false}
                    mwidth="sm"
                    mFullWidth
                    dialogContent={
                        <Box sx={{ width: "100%", pt: 0.5 }}>
                            <Box sx={{ mb: 1, fontWeight: 700, overflowWrap: "anywhere" }}>
                                Why do you want to reject this bill?
                            </Box>
                            <TextField
                                autoFocus
                                fullWidth
                                required
                                multiline
                                minRows={3}
                                label="Rejection reason"
                                placeholder="Enter reason"
                                value={rejectionReason}
                                onChange={(event) => setRejectionReason(event.target.value)}
                                error={rejectDialog && isEmpty(rejectionReason.trim())}
                                helperText="Reason is mandatory"
                            />
                        </Box>
                    }
                    dialogActions={
                        <>
                            <DismissButton variant="contained" onClick={() => setRejectDialog(false)}>
                                Cancel
                            </DismissButton>
                            <SnpButton variant="contained" mbgcolor="#b42318" onClick={rejectBill}>
                                Reject Bill
                            </SnpButton>
                        </>
                    }
                />
                <DialogBox
                    showDialog={reasonDialog}
                    title="Rejection Reason"
                    onClose={() => setReasonDialog(false)}
                    mwidth="sm"
                    dialogContent={<Box sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{billData?.reason ?? ""}</Box>}
                    dialogActions={
                        <DismissButton variant="contained" onClick={() => setReasonDialog(false)}>
                            Close
                        </DismissButton>
                    }
                />
                <DialogBox
                    showDialog={deliveredDialog}
                    title="Delivery Completed"
                    onClose={() => setDeliveredDialog(false)}
                    mwidth="sm"
                    dialogContent={
                        <Box sx={{ textAlign: "center", color: "#198754", fontWeight: 700 }}>
                            Delivered successfully
                        </Box>
                    }
                    dialogActions={
                        <DismissButton variant="contained" onClick={() => setDeliveredDialog(false)}>
                            Close
                        </DismissButton>
                    }
                />
                < DialogBox
                    showDialog={showItemDialog}
                    title={"Stock Info"}
                    onClose={handleItemDialogClose}
                    dialogContent={renderDialogContent}
                    dialogActions={renderItemDialogAction()}
                />
                < DialogBox
                    showDialog={comboDialog}
                    title={"Combo Details"}
                    onClose={handleComboDialogClose}
                    dialogContent={renderComboDialog()}
                    dialogActions={renderComboDialogAction()}
                />
                {
                    !isEmpty(billData?.id ?? "") &&
                    <DialogBox
                        showDialog={statusDialog}
                        title="Updare Delivery Information"
                        onClose={() => setStatusDialog(false)}
                        dialogContent={<DeliveryStatusChange
                            billData={billData}
                            setBillData={setBillData} />
                        }
                        dialogActions={dialogActionButton()}
                    ></DialogBox>
                }
            </Grid>
        );
    };

    return (
        <SnpComponent showDialog={snpComponent.showDialog}
            isLoader={snpLoader}
            title={snpComponent.title}
            subTitle={snpComponent.subTitle}
            negativeAction={snpComponent.negativeAction}
            positiveReq={snpComponent.positiveReq}
            positiveAction={snpComponent.positiveAction}
            negativeReq={snpComponent.negativeReq}
            handleDialogClose={() => setSnpComponent(INITIAL_SNP_COMPONENT)}
            iconReq={snpComponent.iconReq}
            iconContent={snpComponent.iconContent}
            content={renderSnpContent()}
            onSnackClose={() => setSnpComponent({
                ...snpComponent,
                snackBarOpen: false,
                snackBarMsg: "",
            })}
            cancelExtra={snpComponent.cancelExtra}
            snackBarOpen={snpComponent.snackBarOpen}
            snackBarMsg={snpComponent.snackBarMsg}
            outSideClickDismiss={snpComponent.outSideClickDismiss}
            gui={snpComponent.gui}
            snackHorizontal={snpComponent.snackHorizontal}
            snackVertical={snpComponent.snackVertical}
            snackColor={snpComponent.snackColor}
            onCancel={snpComponent.handleSnpCancel}
            handleSubmit={snpComponent.handleSnpSubmit}
        />
    )
}
